module.exports = __webpack_public_path__ + "static/Full-stack Web Development-0042eb0cf399b19b1b96b2912854b741.png";